const _plans = [
  {
    recommended: true,
    recommendedReason: 'fixed',
    plan: {
      contractTermMonths: 9,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '9-month Partner Saver',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=9-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '9-month Partner Saver',
      nameId: '9-month-partner-saver',
      partnerId: '451dc8f4-b25f-4b63-98b5-f147a042ba57',
      pricing: {
        kwh1000: 9.1,
        kwh2000: 8.9,
        kwh500: 11.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '36-month Partner Saver',
      earlyTerminationFee: 30000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=36-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '36-month Partner Saver',
      nameId: '36-month-partner-saver',
      partnerId: '23748ce3-de45-4f1e-9ff1-fd750ad877e5',
      pricing: {
        kwh1000: 9.1,
        kwh2000: 8.9,
        kwh500: 11.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '36 mo Nest Rate',
      earlyTerminationFee: 30000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=36%20mo%20Nest%20Rate&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '36 mo Nest Rate',
      nameId: '36-mo-nest-rate',
      partnerId: '5ecd4af6-093a-4cdc-8f5f-5faddac001f9',
      pricing: {
        kwh1000: 9.1,
        kwh2000: 8.9,
        kwh500: 11.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Nest',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21384/YRAC',
      description:
        'Market rates can go up and down, but with this plan, you can lock in your rate for 24 months so you don’t have to worry. Your rate stays put, guaranteed. With this fixed rate, there’s an $8.99 monthly service fee and a $100 early cancellation fee. Enjoy peace of mind with a fixed rate.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21384/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Price Protect 24',
      nameId: 'price-protect-24',
      partnerId: 'a45d66cb-9816-4494-a3b1-9d6484892f47',
      pricing: {
        kwh1000: 9.1704,
        kwh2000: 8.9994,
        kwh500: 11.3104,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21384/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 9,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '9-Month Partner Simple',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=9-Month%20Partner%20Simple&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '9-Month Partner Simple',
      nameId: '9-month-partner-simple',
      partnerId: '00ac0d77-992f-41d1-a1c6-4edd28bcbbd3',
      pricing: {
        kwh1000: 9.3,
        kwh2000: 9.1,
        kwh500: 9.6,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Simple',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '24 mo Nest Rate',
      earlyTerminationFee: 25000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=24%20mo%20Nest%20Rate&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '24 mo Nest Rate',
      nameId: '24-mo-nest-rate',
      partnerId: '30193e33-c595-4859-84c9-f1d94c39530e',
      pricing: {
        kwh1000: 9.3,
        kwh2000: 9.1,
        kwh500: 11.6,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Nest',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '24-month Partner Saver',
      earlyTerminationFee: 25000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=24-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '24-month Partner Saver',
      nameId: '24-month-partner-saver',
      partnerId: 'fa3b3101-ab80-4830-8bf8-c2b7cdddac31',
      pricing: {
        kwh1000: 9.3,
        kwh2000: 9.1,
        kwh500: 11.6,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '36-Month Partner Simple',
      earlyTerminationFee: 30000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=36-Month%20Partner%20Simple&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '36-Month Partner Simple',
      nameId: '36-month-partner-simple',
      partnerId: '7613c489-67da-4324-9206-dfabecf38431',
      pricing: {
        kwh1000: 9.3,
        kwh2000: 9.1,
        kwh500: 9.6,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Simple',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 60,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '60-month Partner Saver',
      earlyTerminationFee: 30000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=60-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '60-month Partner Saver',
      nameId: '60-month-partner-saver',
      partnerId: '55ff0858-dae9-4ffa-8280-402043a09fdf',
      pricing: {
        kwh1000: 9.3,
        kwh2000: 9.1,
        kwh500: 11.6,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 60,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '60-Month Partner Simple',
      earlyTerminationFee: 30000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=60-Month%20Partner%20Simple&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '60-Month Partner Simple',
      nameId: '60-month-partner-simple',
      partnerId: '138ce1e0-c468-441d-a340-febeb2b4fa05',
      pricing: {
        kwh1000: 9.3,
        kwh2000: 9.1,
        kwh500: 9.6,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Simple',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20783/YRAC',
      description:
        'If you are tired of keeping track of paper bills and due dates, enroll in paperless billing and automatic payments! With this plan you have locked in a low rate for 12 months. Also there is a monthly fee of $8.99 applies when usage is below 1,000 kWh and early cancellation fee of $175.00.',
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20783/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Price Protect 12',
      nameId: 'price-protect-12',
      partnerId: 'e554878b-9960-4cd0-88f1-8eca0bc1db27',
      pricing: {
        kwh1000: 9.2704,
        kwh2000: 9.0994,
        kwh500: 11.4104,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20783/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21473/YRAC',
      description:
        'Market rates can go up and down, but with this plan, you can lock in your rate for 36 months so you don’t have to worry. Your rate stays put, guaranteed. With this fixed rate, there’s an $8.99 monthly service fee which applies when your usage is below $1000 kWh in a billing cycle and has a $250.00 early cancellation fee.  Enjoy peace of mind with a fixed rate.',
      earlyTerminationFee: 25000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21473/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Price Protect 36',
      nameId: 'price-protect-36',
      partnerId: 'af95f338-b911-40d8-aeea-a6854323d1b2',
      pricing: {
        kwh1000: 9.3704,
        kwh2000: 9.1994,
        kwh500: 11.5104,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21473/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '12-month Partner Saver',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=12-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '12-month Partner Saver',
      nameId: '12-month-partner-saver',
      partnerId: '82eb270f-7d88-4a2c-818f-3eb5b8204992',
      pricing: {
        kwh1000: 9.4,
        kwh2000: 9.2,
        kwh500: 11.8,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCTMARKETING/Entrust.YRAC.06132019.English_b75cb338-bfcb-452e-bc50-80b0d3516d2a.pdf',
      description:
        'Lock in and get satisfaction with no rising rate for 24 months. Let us show you our excellent customer service!',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCT/TXN1F24C0DG009_20190617_eng_3f3fb6cd-8483-4148-9276-f1b21b5029e9.pdf',
      greenPercentage: 15.5,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Entrust 24',
      nameId: 'entrust-24',
      partnerId: 'e0176f3c-65be-4581-b26f-0042d2d01a5f',
      pricing: {
        kwh1000: 9.6,
        kwh2000: 9.2,
        kwh500: 10.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/entrust.png',
      providerName: 'entrust energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCTMARKETING/Entrust.TOS.06132019.English_27dfca9c-0d24-4bea-84f8-bb4a52043554.pdf',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21285/YRAC',
      description:
        'Sure Saver 12 allows you to lock into a low rate for 12 months but the best part of this plan is the $60.00/monthly service fee credit you will receive if usage is greater than 999 kwh.  This plan includes an early termination fee of $100.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21285/EFL_MSFCREDIT',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Sure Saver 12',
      nameId: 'sure-saver-12',
      partnerId: '1652fb5d-6257-4fc1-93d7-5f4265675832',
      pricing: {
        kwh1000: 8.6604,
        kwh2000: 11.4894,
        kwh500: 15.0024,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21285/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 9,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21448/YRAC',
      description:
        'With this plan you have locked in a competitive rate for 9 months.  There is a monthly fee of $8.99 when usage is below 1000 kwh.  There is a $150 cancellation fee with this fixed rate.',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21448/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Price Protect 9',
      nameId: 'price-protect-9',
      partnerId: '039b76e0-4d12-4aaa-97a2-fb87843e8ae4',
      pricing: {
        kwh1000: 9.4604,
        kwh2000: 9.2894,
        kwh500: 11.6004,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21448/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 18,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '18-month Partner Saver',
      earlyTerminationFee: 25000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=18-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '18-month Partner Saver',
      nameId: '18-month-partner-saver',
      partnerId: '1e98d922-9986-4dd7-afda-13674c79b692',
      pricing: {
        kwh1000: 9.5,
        kwh2000: 9.3,
        kwh500: 11.8,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '24-Month Partner Simple',
      earlyTerminationFee: 25000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=24-Month%20Partner%20Simple&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '24-Month Partner Simple',
      nameId: '24-month-partner-simple',
      partnerId: '31b380b9-b4e8-4085-97c8-a8e4f800a293',
      pricing: {
        kwh1000: 9.5,
        kwh2000: 9.3,
        kwh500: 9.8,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Simple',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21456/YRAC',
      description:
        'A great time for New Customers to lock in your fixed rate and have No MSF.  With this plan, you can lock in your rate for 24 months so you don’t have to worry.   Enjoy peace of mind with this plan.  There’s a $100 cancellation fee with this fixed rate.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21456/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Choice 24',
      nameId: 'choice-24',
      partnerId: '82c836a6-937b-46c5-a8d4-5da633093a5f',
      pricing: {
        kwh1000: 9.5204,
        kwh2000: 9.3494,
        kwh500: 9.8624,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21456/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCTMARKETING/Entrust.YRAC.06132019.English_ea6af06c-94a9-4178-b548-0e55bc9e40db.pdf',
      description:
        'Secure your rate for 12 months and avoid rate fluctuations. Sign up today and experience the Entrust Energy difference!',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCT/TXN1F12C0DG009_20190617_eng_9f24e13d-9cc8-44c6-a7cd-764d8207d75d.pdf',
      greenPercentage: 15.5,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Entrust 12',
      nameId: 'entrust-12',
      partnerId: '97aacb7c-4d43-427e-afc9-bc5a85c6c065',
      pricing: {
        kwh1000: 9.6,
        kwh2000: 9.2,
        kwh500: 10.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/entrust.png',
      providerName: 'entrust energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCTMARKETING/Entrust.TOS.06132019.English_f0330e00-2b97-424c-b02e-4e55a019cf4c.pdf',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '12-Month Partner Simple',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=12-Month%20Partner%20Simple&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '12-Month Partner Simple',
      nameId: '12-month-partner-simple',
      partnerId: 'cd2d1997-1421-468c-a0ba-d8778c8456b0',
      pricing: {
        kwh1000: 9.6,
        kwh2000: 9.4,
        kwh500: 10,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Simple',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 6,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '6-month Partner Saver',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=6-month%20Partner%20Saver&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '6-month Partner Saver',
      nameId: '6-month-partner-saver',
      partnerId: '4bdfc4e1-ae3b-4d59-9bb0-02e394df1a0e',
      pricing: {
        kwh1000: 9.7,
        kwh2000: 9.6,
        kwh500: 12.1,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Fixed',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 9,
      customerRightsUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCTMARKETING/Entrust.YRAC.06132019.English_25771898-c898-4db2-aeaf-ed19f26ce8e9.pdf',
      description:
        'Sign up today and experience the Entrust Energy difference!',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCT/TXN1F09C0DG009_20190617_eng_f3244a2f-0c34-4c92-bcca-7671bea298c2.pdf',
      greenPercentage: 15.5,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Entrust 9',
      nameId: 'entrust-9',
      partnerId: 'd3d2b637-2a6b-4010-a498-f254df8b98cb',
      pricing: {
        kwh1000: 10,
        kwh2000: 9.6,
        kwh500: 10.8,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/entrust.png',
      providerName: 'entrust energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://s3-us-west-2.amazonaws.com/ironhide.operations/PRODUCTMARKETING/Entrust.TOS.06132019.English_6cddbed9-0d84-4c80-adbd-e67e8bebc082.pdf',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 6,
      customerRightsUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/your-rights-as-a-customer',
      description: '6-Month Partner Simple',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/electricity-facts-label?ldcName=Oncor&rateDescriptor=6-Month%20Partner%20Simple&businessEntityAliasId=2',
      greenPercentage: 4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: '6-Month Partner Simple',
      nameId: '6-month-partner-simple',
      partnerId: '76b55c72-f17d-4539-bd90-66fbfef5f021',
      pricing: {
        kwh1000: 9.9,
        kwh2000: 9.8,
        kwh500: 10.3,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/infinite.png',
      providerName: 'infinite energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://sandbox.infiniteenergy.com/enrollments/pdf/IE/terms-of-service',
      type: 'Simple',
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21454/YRAC',
      description:
        'A great time for New Customers to lock in your fixed rate and have No MSF.  With this plan, you can lock in your rate for 12 months so you don’t have to worry.   Enjoy peace of mind with this plan.  There’s a $100 cancellation fee with this fixed rate.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21454/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Choice 12',
      nameId: 'choice-12',
      partnerId: 'ba767819-8735-4fbc-9310-136078896978',
      pricing: {
        kwh1000: 9.9604,
        kwh2000: 9.7894,
        kwh500: 10.3024,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21454/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 18,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21455/YRAC',
      description:
        'A great time for New Customers to lock in your fixed rate and have No MSF.  With this plan, you can lock in your rate for 18 months so you don’t have to worry.   Enjoy peace of mind with this plan.  There’s a $100 cancellation fee with this fixed rate.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21455/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Choice 18',
      nameId: 'choice-18',
      partnerId: 'd3ff06d8-eca7-42a8-b718-e44d69e7b3eb',
      pricing: {
        kwh1000: 9.9704,
        kwh2000: 9.7994,
        kwh500: 10.3124,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21455/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://gexaapidev.azure-api.net/docs/api/documents/get/type/yraac',
      description: 'EveryDay | EveryNight',
      earlyTerminationFee: 15000,
      electricityFactsLabelUrl:
        'https://gexaapidev.azure-api.net/docs/api/documents/get/type/efl/id/59a5b43c26103c21bc46453e',
      greenPercentage: 6,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'EveryDay | EveryNight 12',
      nameId: 'everyday-everynight-12',
      partnerId: '3c57dba9-d1ba-438d-9265-fd6d0c018ed5',
      pricing: {
        kwh1000: 9.9,
        kwh2000: 9.6,
        kwh500: 12.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/gexa.png',
      providerName: 'gexa energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19,
      termsOfServiceUrl:
        'https://gexaapidev.azure-api.net/docs/api/documents/get/type/ftos',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 15,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146171/YRAC',
      description:
        'A great time for New Customers to lock in your fixed rate and have No MSF. With this plan, you can lock in your rate for 15 months so you don’t have to worry. Enjoy peace of mind with this plan. There’s a $100 cancellation fee with this fixed rate.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146171/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Choice 15',
      nameId: 'choice-15',
      partnerId: '4c519b32-1070-4ff9-be51-f937c5e8e5a2',
      pricing: {
        kwh1000: 10.1004,
        kwh2000: 9.9294,
        kwh500: 10.4424,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146171/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 6,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21284/YRAC',
      description:
        'Sure Saver 6 allows you to lock into a low rate for 6 months but the best part of this plan is the $60.00/monthly service fee credit you will receive if usage is greater than 999 kwh.  This plan includes an early termination fee of $100.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21284/EFL_MSFCREDIT',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Sure Saver 6',
      nameId: 'sure-saver-6',
      partnerId: 'fc3cdc92-94a4-4c76-9058-e82409ca075c',
      pricing: {
        kwh1000: 9.7204,
        kwh2000: 12.5494,
        kwh500: 16.0624,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21284/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'http://portal.frontierutilities.com/frontierefl2/eflviewer.aspx?lang=EN&prodcode=TOSP',
      description: 'Test',
      earlyTerminationFee: 20000,
      electricityFactsLabelUrl:
        'http://portal.frontierutilities.com/frontierefl2/eflviewer.aspx?lang=EN&prodcode=BTH12%2b&tdspcode=ONCOR_ELEC',
      greenPercentage: 6,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Beat the Heat 12+',
      nameId: 'beat-the-heat-12',
      partnerId: '2cddaf38-1040-4ba3-b447-d9f5ae80c32e',
      pricing: {
        kwh1000: 10.9,
        kwh2000: 8.4,
        kwh500: 12.1,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/frontier.png',
      providerName: 'frontier',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 18.9,
      termsOfServiceUrl:
        'http://portal.frontierutilities.com/frontierefl2/eflviewer.aspx?lang=EN&prodcode=TOS',
      type: null,
    },
  },
  {
    recommended: true,
    recommendedReason: 'renewable',
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20778/YRAC',
      description:
        'Our 100% renewable electricity plan is environmentally friendly and this great rate stays put, guaranteed, for 12 months. With this fixed rate, there’s a $175 early cancellation fee. A monthly fee of $8.99 is waived when your usage is over 1,000 kWh.',
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20778/EFL',
      greenPercentage: 100,
      isFixedPricing: true,
      isGreen: true,
      isVariablePricing: false,
      name: 'Green Price Protect 12',
      nameId: 'green-price-protect-12',
      partnerId: 'e2199203-b06c-42e2-80de-be0fdaaae276',
      pricing: {
        kwh1000: 11.0704,
        kwh2000: 10.8994,
        kwh500: 13.2104,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'renewable',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20778/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://refer.directenergy.com/imageserver/Documents/DocumentName?type=YRAC',
      description: null,
      earlyTerminationFee: 13500,
      electricityFactsLabelUrl:
        'https://refer.directenergy.com/imageserver/Documents/DocumentName?type=EFL&name=FFORXXX0640_ENG_20181204.PDF',
      greenPercentage: 16.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'You Got This™ 24',
      nameId: 'you-got-this-24',
      partnerId: '786a7273-0fbe-4a7d-a5a1-9740ae56a3f4',
      pricing: {
        kwh1000: 11.1,
        kwh2000: 10.7,
        kwh500: 12,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/firstchoice.png',
      providerName: 'first choice power',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 18.9,
      termsOfServiceUrl:
        'https://refer.directenergy.com/imageserver/Documents/DocumentName?type=TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 6,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20782/YRAC',
      description:
        'If you are tired of keeping track of paper bills and due dates, enroll in paperless billing and automatic payments! With this plan you have locked in a low rate for 6 months. Also there is a monthly fee of $8.99 applies when usage is below 1,000 kWh and early cancellation fee of $100.00.',
      earlyTerminationFee: 10000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20782/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Price Protect 6',
      nameId: 'price-protect-6',
      partnerId: '40ff49be-ea4c-4040-be55-8d189abf9316',
      pricing: {
        kwh1000: 11.1604,
        kwh2000: 10.9894,
        kwh500: 13.3004,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/20782/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://refer.directenergy.com/imageserver/Documents/DocumentName?type=YRAC',
      description: null,
      earlyTerminationFee: 13500,
      electricityFactsLabelUrl:
        'https://refer.directenergy.com/imageserver/Documents/DocumentName?type=EFL&name=FFORXXX0643_ENG_20181204.PDF',
      greenPercentage: 16.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'You Got This™ 12',
      nameId: 'you-got-this-12',
      partnerId: '2ec83726-964b-4813-b315-210c255204f1',
      pricing: {
        kwh1000: 11.2,
        kwh2000: 10.8,
        kwh500: 12.1,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/firstchoice.png',
      providerName: 'first choice power',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 18.9,
      termsOfServiceUrl:
        'https://refer.directenergy.com/imageserver/Documents/DocumentName?type=TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 6,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21471/YRAC',
      description:
        'Market rates can go up and down, but with this plan, you can lock in your rate for 6 months so you don’t have to worry. Your rate stays put, guaranteed. With this fixed rate, there’s a $175 early cancellation fee. Enjoy peace of mind with a fixed rate and more money in your pocket.',
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21471/EFL',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'CHOICE 6',
      nameId: 'choice-6',
      partnerId: '9d61c14a-82c3-488e-b480-8b7c8f331b0b',
      pricing: {
        kwh1000: 11.4704,
        kwh2000: 11.2994,
        kwh500: 11.8124,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/21471/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://webstest.taraenergy.com/Generate_Docs/TosYracLink.aspx?RID=hlyXNpKiwg0=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webstest.taraenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=hlyXNpKiwg0=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Tara Web - 36',
      nameId: 'tara-web-36',
      partnerId: '162de1b3-4748-44a9-b745-0ab388fd57e4',
      pricing: {
        kwh1000: 12.4,
        kwh2000: 12.4,
        kwh500: 12.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/tara.png',
      providerName: 'tara energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webstest.taraenergy.com/Generate_Docs/TosYracLink.aspx?RID=hlyXNpKiwg0=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/TosYracLink.aspx?RID=c1zhznoaYis=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=c1zhznoaYis=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Amigo Web Plan - 36',
      nameId: 'amigo-web-plan-36',
      partnerId: 'db909d20-ceea-426d-b7cb-c2da2afd4789',
      pricing: {
        kwh1000: 12.4,
        kwh2000: 12.4,
        kwh500: 12.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/amigo.png',
      providerName: 'amigo energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/TosYracLink.aspx?RID=c1zhznoaYis=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 36,
      customerRightsUrl:
        'https://webs.testjustenergy.com/Generate_Docs/TosYracLink.aspx?RID=5XFeGIkhzDY=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webs.testjustenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=5XFeGIkhzDY=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Just Energy Web Plan - 36',
      nameId: 'just-energy-web-plan-36',
      partnerId: 'c38d6e64-9231-408f-9a3f-d509915ad2b3',
      pricing: {
        kwh1000: 12.4,
        kwh2000: 12.4,
        kwh500: 12.4,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/just.png',
      providerName: 'just energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webs.testjustenergy.com/Generate_Docs/TosYracLink.aspx?RID=5XFeGIkhzDY=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/TosYracLink.aspx?RID=YGx9WAjhdAE=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=YGx9WAjhdAE=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Amigo Web Plan - 24',
      nameId: 'amigo-web-plan-24',
      partnerId: '75a55845-708a-4d24-ace1-938fd37fb410',
      pricing: {
        kwh1000: 13.1,
        kwh2000: 13.1,
        kwh500: 13.1,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/amigo.png',
      providerName: 'amigo energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/TosYracLink.aspx?RID=YGx9WAjhdAE=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://webs.testjustenergy.com/Generate_Docs/TosYracLink.aspx?RID=Wg/3TzfePHc=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webs.testjustenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=Wg/3TzfePHc=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Just Energy Web Plan - 24',
      nameId: 'just-energy-web-plan-24',
      partnerId: 'e768248f-9c87-4224-b3bd-fbe3e7943ab2',
      pricing: {
        kwh1000: 13.1,
        kwh2000: 13.1,
        kwh500: 13.1,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/just.png',
      providerName: 'just energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webs.testjustenergy.com/Generate_Docs/TosYracLink.aspx?RID=Wg/3TzfePHc=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 24,
      customerRightsUrl:
        'https://webstest.taraenergy.com/Generate_Docs/TosYracLink.aspx?RID=JXAXQJ+ETqA=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webstest.taraenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=JXAXQJ+ETqA=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Tara Web - 24',
      nameId: 'tara-web-24',
      partnerId: 'c6d08f79-6ab3-48a6-b2ea-5561a6a261aa',
      pricing: {
        kwh1000: 13.1,
        kwh2000: 13.1,
        kwh500: 13.1,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/tara.png',
      providerName: 'tara energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webstest.taraenergy.com/Generate_Docs/TosYracLink.aspx?RID=JXAXQJ+ETqA=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/TosYracLink.aspx?RID=TCJQgiD22QY=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=TCJQgiD22QY=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Amigo Web Plan - 12',
      nameId: 'amigo-web-plan-12',
      partnerId: 'fcb646ab-f037-49e2-86f8-0b5a0f018988',
      pricing: {
        kwh1000: 13.3,
        kwh2000: 13.3,
        kwh500: 13.3,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/amigo.png',
      providerName: 'amigo energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webstest.amigoenergy.com/Generate_Docs/TosYracLink.aspx?RID=TCJQgiD22QY=&RCID=k14MgmCobB4=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://webs.testjustenergy.com/Generate_Docs/TosYracLink.aspx?RID=8Q6XY2sbyd0=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webs.testjustenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=8Q6XY2sbyd0=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Just Energy Web Plan - 12',
      nameId: 'just-energy-web-plan-12',
      partnerId: '7d925549-8b0a-4126-b837-8e8c42784488',
      pricing: {
        kwh1000: 13.3,
        kwh2000: 13.3,
        kwh500: 13.3,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/just.png',
      providerName: 'just energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webs.testjustenergy.com/Generate_Docs/TosYracLink.aspx?RID=8Q6XY2sbyd0=&RCID=AgXt34oSEek=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://webstest.taraenergy.com/Generate_Docs/TosYracLink.aspx?RID=xI8LTgukAlg=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      description: null,
      earlyTerminationFee: 17500,
      electricityFactsLabelUrl:
        'https://webstest.taraenergy.com/Generate_Docs/Generate_EflLinks.aspx?RID=xI8LTgukAlg=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      greenPercentage: 10.4,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Tara Web - 12',
      nameId: 'tara-web-12',
      partnerId: '01fe3719-6b5a-41d8-ba38-da212ca23895',
      pricing: {
        kwh1000: 13.3,
        kwh2000: 13.3,
        kwh500: 13.3,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/tara.png',
      providerName: 'tara energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://webstest.taraenergy.com/Generate_Docs/TosYracLink.aspx?RID=xI8LTgukAlg=&RCID=c7MUHgpOW8w=&L=6f+Ch9flI7k=',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/144139/YRAC',
      description:
        "No more bill shock. Get started now on Spark Instant Plus 12 and know how much you'll pay for electricity every month.",
      earlyTerminationFee: 20000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/144139/EFL_TIEREDPRICING',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Spark Instant Plus 12',
      nameId: 'spark-instant-plus-12',
      partnerId: '17a31fe1-7816-409a-ba25-28a01dc95522',
      pricing: {
        kwh1000: 22,
        kwh2000: 11,
        kwh500: 44,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/144139/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 6,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146206/YRAC',
      description:
        "No more bill shock. Get started now on Spark Instant Plus 6, manage your electricity consumption, and know how much you'll pay for electricity every month.",
      earlyTerminationFee: 20000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146206/EFL_TIEREDPRICING',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Spark Instant Plus 6',
      nameId: 'spark-instant-plus-6',
      partnerId: 'f65acdec-ae63-4d02-9f59-12db7fb98da4',
      pricing: {
        kwh1000: 22.5,
        kwh2000: 11.25,
        kwh500: 45,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146206/TOS',
      type: null,
    },
  },
  {
    recommended: false,
    recommendedReason: null,
    plan: {
      contractTermMonths: 12,
      customerRightsUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146057/YRAC',
      description: 'Instant Boost 12',
      earlyTerminationFee: 20000,
      electricityFactsLabelUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146057/EFL_TIEREDPRICING',
      greenPercentage: 0,
      isFixedPricing: true,
      isGreen: false,
      isVariablePricing: false,
      name: 'Instant Boost 12',
      nameId: 'instant-boost-12',
      partnerId: 'd05a1081-e15a-4e1e-bfc6-49aa748d3bcd',
      pricing: {
        kwh1000: 29.5,
        kwh2000: 14.75,
        kwh500: 59,
      },
      providerImageUrl: 'http://assets.wattbuy.com/images/spark.png',
      providerName: 'spark energy',
      providerPlanUrl: null,
      rateType: 'fixed',
      state: 'tx',
      stateRenewablePercentage: 19.1,
      termsOfServiceUrl:
        'https://devreact.wattbuy.com/product-document/spark-energy/146057/TOS',
      type: null,
    },
  },
];

const workingImages = {
  frontier: 'https://wattbuy.com/5a2cfefcb14c0b0e3ec26c9ca2bb625d.png',
  'gexa energy': 'https://wattbuy.com/30b9eab646e1fcc6156c1404edd600a5.png',
  'infinite energy': 'https://wattbuy.com/7e1b3b03377395c2396c8617776e9028.png',
};

export const plans = _plans
  .map(({ recommended, recommendedReason, plan }) => ({
    recommended,
    recommendedReason,
    ...plan,
  }))
  .filter(({ providerImageUrl }) => providerImageUrl);

window.plans = plans;
